__turbopack_context__.v({
  "buttons": "ActiveFiltersList-module-scss-module___DO2Wq__buttons",
  "clear-all-pill": "ActiveFiltersList-module-scss-module___DO2Wq__clear-all-pill",
  "group": "ActiveFiltersList-module-scss-module___DO2Wq__group",
  "main": "ActiveFiltersList-module-scss-module___DO2Wq__main",
  "pill": "ActiveFiltersList-module-scss-module___DO2Wq__pill",
  "pill-close": "ActiveFiltersList-module-scss-module___DO2Wq__pill-close",
});
